import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CompareComponent } from './compare.component';
import { SharedModule } from '../shared/shared.module'

export const COMPARE_ROUTES = [
  { path: '', component: CompareComponent }
];

@NgModule({
  imports: [SharedModule,
            RouterModule.forChild(COMPARE_ROUTES)],
  declarations: [CompareComponent],
})
export class CompareModule {}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/compare/compare.module.ts